import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
//api
import { deleteBookStore } from 'api/company';
import { getBookStores } from 'api/pathForHook/company';
//utils
import useHandleSearch from 'utils/customHooks/useHandleSearch';
// slices
import { companySelector } from 'slices/company';
//herlpers
import { verificateNullValue } from 'helpers';
//components
import CustomTable from 'components/backoffice/customTable';
import DropdownIcons from 'components/backoffice/dropDownIcons';
import DeleteModalCustom from 'components/backoffice/modals/DeleteModalCustom';
import Button from 'components/backoffice/buttonCustom';
import Title from 'components/backoffice/texts/title';
import { usePermissions } from 'components/backoffice/PermissionsContext';
import FiltersTable from './FiltersTable';

const BookStores = () => {
  const { code: companyCode } = useSelector(companySelector);
  const userPermissions = usePermissions();
  const navigate = useNavigate();
  const [listBookStores, setListBookStores] = useState([]);
  const [page, setPage] = useState(1);
  const [formFilter, setFormFilter] = useState({
    name: '',
    code: '',
    email: '',
  });
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [idItem, setIdItem] = useState();
  const [responseInfo, setResponseInfo] = useState({});
  const { setTitle } = useOutletContext()

  const { t } = useTranslation(['backoffice']);

  const colsBookStores = [t('nombre'), `${t('enlace')}(U.R.L)`, t('correoelectronico'), t('libelista'), 'Código', t('actions')];

  const { fetchData, stateData, loading } = useHandleSearch();

  const getListBookStores = async () => {
    try {
      let payload = {
        page,
        page_size: 10,
        name: formFilter.name || '',
        code: formFilter.code || '',
        email: formFilter.email || '',
        fields: 'id,name,web_url,email,libelista_affiliate,code',
      }
      const response = await fetchData(getBookStores(), payload);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTitle(t('librerias'))
    return () => {
      setTitle('');
    };
  }, [setTitle])

  useEffect(() => {
    const { results, errors, totalPages, noResults } = stateData;

    if (results !== null) {
      setListBookStores(results);
      setResponseInfo({ errors, totalPages, noResults });
    } else {
      setListBookStores(null);
      setResponseInfo({ errors });
    }
  }, [stateData])

  useEffect(() => {
    getListBookStores();
  }, [page, formFilter]);

  const handleClear = () => {
    setFormFilter({
      name: '',
      code: '',
      email: '',
    });
    setPage(1);
    setResponseInfo(prevResponseInfo => ({ ...prevResponseInfo, noResults: false }))
    getListBookStores();
  };

  const handleCreate = () => navigate(`/intranet/bookstores/create`);
  const handleEdit = (id) => navigate(`/intranet/bookstores/edit/${id}`);

  const handleShowModalDelete = (item, id, setOpenModal) => {
    if (item.id === id) {
      setOpenModal(true);
      setIdItem(id);
    }
  };

  const handleDelete = useCallback(async () => {
    try {
      const { status } = await deleteBookStore(idItem);
      if (status === 204) {
        toast.success(t('eliminadocorrectamente'));
        setFormFilter({
          name: '',
          code: '',
          email: '',
        });
      } else {
        toast(`${t('error')} ${status}: ${t('mensajeerror')}`);
      }
    } catch (error) {
      console.log(error);
    }
  }, [showModalDelete]);


  return (
    <div className="d-lg-grid">
      <Title text={t('librerias')} />
      <Row className="d-flex w-md-100 mt-3">
        <Col xl={11} lg={12} md={12} xs={12} className="d-flex text-start">
          <FiltersTable
            formFilter={formFilter}
            handleClear={handleClear}
            setFormFilter={setFormFilter}
            t={t}
            page={page}
            setPage={setPage}
          />
        </Col>
        <Col xl={1} lg={12} md={12} xs={12} className="d-flex text-end align-bottom p-xl-0 justify-content-end pt-5 pt-xl-0">
          {userPermissions.includes('empresa.__add') && (
            <Button color={'primary'} onClick={handleCreate} role="button">
              {t('crear')}
            </Button>
          )}
        </Col>
      </Row>
      <div className="table-responsive">
        <CustomTable
          cols={colsBookStores}
          noResults={responseInfo?.noResults}
          isLoading={loading}
          page={page}
          changePage={setPage}
          totalPages={responseInfo?.totalPages}
        >
          {listBookStores &&
            listBookStores?.map((listBookStore, index) => {
              return (
                <tr key={listBookStore.id}>
                  <td>{verificateNullValue(listBookStore?.name)}</td>
                  <td>{verificateNullValue(listBookStore.web_url)}</td>
                  <td>{listBookStore.email}</td>
                  <td> {listBookStore.libelista_affiliate === false ? 'No' : 'Si'}</td>
                  <td>{verificateNullValue(listBookStore.code)}</td>
                  <td className=" item-dropdown text-end">
                    <DropdownIcons
                      idItem={index}
                      handleEdit={
                        userPermissions.includes('empresa.__modify') && (() => handleEdit(listBookStore.id))
                      }
                      handleDelete={
                        userPermissions.includes('empresa.__delete') && 
                        listBookStore.code !== companyCode && 
                        (() => handleShowModalDelete(listBookStore, listBookStore.id, setShowModalDelete))
                      }
                    />
                  </td>
                </tr>
              );
            })}
        </CustomTable>
      </div>
      <DeleteModalCustom
        openModal={showModalDelete}
        setOpenModal={setShowModalDelete}
        handleDelete={handleDelete}
        deleteTitle={t('deletebookstore')}
        beforeTitle={t('librerias')}
      />
    </div>
  );
};

export default BookStores;
